import * as React from "react";
const SvgFiRrBookSpells = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v15c0 2.206 1.794 4 4 4h11c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5M7 2h10c1.654 0 3 1.346 3 3v11H6a4 4 0 0 0-2 .537V5c0-1.654 1.346-3 3-3m10 20H6c-1.103 0-2-.897-2-2s.897-2 2-2h14v1c0 1.654-1.346 3-3 3m-5.243-11.47 1.418-.354.354-1.418a1 1 0 0 1 1.94 0l.351 1.406 1.404.325a1 1 0 0 1 .035 1.94l-1.432.385-.357 1.43a1 1 0 0 1-1.94 0l-.354-1.418-1.418-.354a1 1 0 0 1 0-1.94zM6 6a.75.75 0 0 1 .472-.697L7.78 4.78l.523-1.308a.75.75 0 0 1 1.394 0l.52 1.301 1.299.492a.748.748 0 0 1 .025 1.392l-1.318.556-.526 1.316a.75.75 0 0 1-1.394 0L7.78 7.221l-1.308-.523A.75.75 0 0 1 6 6"
    />
  </svg>
);
export default SvgFiRrBookSpells;
